import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AppRoutes } from './AppRoutes';
import { COOKIE_KEYS } from 'config/cookieConstants';

const PublicRoute: React.FC = () => {
  const isAuthenticated = !!Cookies.get(COOKIE_KEYS.TOKEN);

  // Se o usuário estiver autenticado, redirecione para a dashboard.
  // O 'replace' evita que o usuário possa voltar para a página de login pelo botão "voltar" do navegador.
  if (isAuthenticated) {
    return <Navigate to={AppRoutes.DASHBOARD} replace />;
  }

  // Se não estiver autenticado, renderiza a rota filha
  return <Outlet />;
};

export default PublicRoute;